export default __webpack_public_path__ + "static/media/picture_about_03.780a7dd7.png";